import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";

// Renders the assistant's GFM markdown via react-markdown. rehypeSanitize
// strips raw HTML so untrusted model text can't inject markup; overrides map
// to the existing .chat__md / .chat__table styles.
export default function Markdown({ text }: { text: string }) {
  return (
    <div className="chat__md">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSanitize]}
        components={{
          table: ({ node, ...props }) => (
            <table className="chat__table" {...props} />
          ),
          // Open links in a new tab; keep them safe.
          a: ({ node, ...props }) => (
            <a target="_blank" rel="noopener noreferrer" {...props} />
          ),
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
